import { StyleSpecification } from "@iventis/mapbox-gl";
import { googleMapBackgroundAssetMetaDataKey } from "../../bridge/mapbox/engine-mapbox-types-and-constants";
import { BasemapDataStore } from "./basemap-data-store";

export type MapBackground = StyleSpecification & { google: boolean; metaData?: { apiKey?: string; sessionToken?: string; name: string } };

export class MapBackgroundDataStore extends BasemapDataStore<MapBackground> {
    protected async getBasemapApiCall(mapBackgroundId: string): Promise<MapBackground> {
        const mapBackgroundAsset = await this.getBasemapAsset(mapBackgroundId);
        const mapBackgroundRequest = await fetch(mapBackgroundAsset.url);
        const mapBackgroundJson = (await mapBackgroundRequest.json()) as Omit<MapBackground, "google">;
        return {
            ...mapBackgroundJson,
            name: mapBackgroundAsset.name,
            google: mapBackgroundAsset.metaData?.[googleMapBackgroundAssetMetaDataKey] === "true",
            metaData: { apiKey: mapBackgroundAsset.metaData?.apiKey, sessionToken: mapBackgroundAsset.metaData?.sessionToken, name: mapBackgroundAsset.name },
        };
    }
}
